import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import Card from '../../components/Card';
import TEXT from '../../components/Text';
import { ButtonSecondary } from '../../components/Button';
import { NumberInputSettings, PercentInput } from '../../components/FormFields';
import { LoadingOutlined } from '@ant-design/icons';
import { Form, Spin } from 'antd';
import {
  getUserMerchants,
  updateMerchantsSystemFee,
  updateMerchantsSystemFeeReplenish,
  updateMerchantsSystemSwapReplenish,
  updateMerchantsRefundFee,
  updateMerchantsMinimumWithdrawal, updateMerchantsSystemFeePercentClient
} from "../../../redux/actions/adminPanel/adminUsers";
import { getAdminSettings } from '../../../redux/actions/adminPanel/adminSettings';
import { ReactComponent as SaveSVG } from '../../../img/adminPanel/save.svg';
import { ReactComponent as SaveSVGInex } from '../../../img/inex/save.svg';
import { ReactComponent as SaveSVGInsta } from '../../../img/instaXchange/save.svg';
import { ReactComponent as SaveSVGCoinera } from '../../../img/coinera/save.svg';
import { scrollContainerIntoView } from '../../helpers/scrollIntoView';
import moment from 'moment';
import './style.scss';
import { identity } from "../../../utils/getIdentity";
import { useTranslation } from "react-i18next";

const saveIcon = {
  cpay: <SaveSVG />,
  nfg: <SaveSVG />,
  finvaro: <SaveSVG />,
  clarnium: <SaveSVG />,
  inex: <SaveSVGInex />,
  insta: <SaveSVGInsta />,
  coinera: <SaveSVGCoinera />
}

const UserMerchants = ({
  userMerchants,
  userMerchantsFetching,
  adminSettingsData,
  systemFeeFetching,
  getUserMerchants,
  updateMerchantsSystemFee,
  getAdminSettings,
  updateMerchantsSystemFeeReplenish,
  systemFeeReplenishFetching,
  systemFeeSwapFetching,
  updateMerchantsSystemSwapReplenish,
  updateMerchantsRefundFee,
  systemRefundFetching,
  updateMerchantsMinimumWithdrawal,
  systemsMinimumWithdrawalFetching,
  permissions,
  systemFeePercentClientFetching,
  updateMerchantsSystemFeePercentClient
}) => {
  const [fetchingId, setFetchingId] = useState({});
  const { userId } = useParams();
  const userMerchantsRef = useRef();
  const { t } = useTranslation();

  useEffect(() => {
    getAdminSettings();
  }, []);

  useEffect(() => {
    setFetchingId(
      userMerchants.reduce((resultObj, merchant) => {
        resultObj[merchant._id] = false;
        return resultObj;
      }, {})
    );
  }, [userMerchants]);

  useEffect(() => {
    if (userId) {
      getUserMerchants(userId, 20);
    }
  }, [userId]);

  useEffect(() => {
    scrollContainerIntoView(userMerchantsRef);
  }, []);

  const updateMerchantFetchingStatus = (merchantId, isFetching) => {
    setFetchingId({ ...fetchingId, [merchantId]: isFetching });
  };

  const updateMerchant = async (merchantId, value, type) => {
    updateMerchantFetchingStatus(merchantId, true);
    if (type === 'withdraw') await updateMerchantsSystemFee(merchantId, value);
    if (type === 'replenish') await updateMerchantsSystemFeeReplenish(merchantId, value);
    if (type === 'replenishClients') await updateMerchantsSystemFeePercentClient(merchantId, value);
    if (type === 'swap') await updateMerchantsSystemSwapReplenish(merchantId, value);
    if (type === 'refund') await updateMerchantsRefundFee(merchantId, value);
    if (type === 'minWithdraw') await updateMerchantsMinimumWithdrawal(merchantId, value);

    updateMerchantFetchingStatus(merchantId, false);
  };

  const spinIndicator = <Spin indicator={<LoadingOutlined className={`spin-${identity}`} style={{ fontSize: 16 }} spin />} />;

  return (
    <div className="user-merchants" ref={userMerchantsRef}>
      <Card>
        <TEXT.pageTitle>{t('admin.fees')}</TEXT.pageTitle>
        <div className="user-merchants__list">
          {!userMerchantsFetching ? (
            userMerchants.map(merchant => (
              <div className="user-merchants__item" key={merchant._id}>
                <div>
                  <div className="user-merchants__name">
                    <TEXT.darkBold>{merchant.name}</TEXT.darkBold>
                  </div>
                  <div className="user-merchants__created-date">
                    <TEXT.sectionDescription>
                      {moment(merchant.createdAt).format('MMMM D, YYYY, HH:mm;')}
                    </TEXT.sectionDescription>
                  </div>
                </div>
                <div className="user-merchants__right-col">
                  <div className="user-merchants__right-col_wrapper">
                    <TEXT.sectionDescription>% {t('admin.fee_withdrawal')}</TEXT.sectionDescription>
                    <Form
                      name="user-merchant-form"
                      initialValues={{
                        systemFeePercent:
                          merchant.systemFee >= 0 ? merchant.systemFee : adminSettingsData.systemFeePercent,
                      }}
                      onFinish={({ systemFeePercent }) => updateMerchant(merchant._id, systemFeePercent, 'withdraw')}
                    >
                      <div className="user-merchants__input-wrap">
                        <PercentInput name="systemFeePercent" className="user-merchants__input" />
                        <button
                          type="submit"
                          className="user-merchants__save"
                          disabled={(systemFeeFetching && fetchingId[merchant._id]) || (permissions && permissions?.length > 0 && !permissions[1]?.edit) || (permissions && permissions?.length > 0 && !permissions[2]?.edit)}
                        >
                          {systemFeeFetching && fetchingId[merchant._id] ? spinIndicator : saveIcon[identity]}
                        </button>
                      </div>
                    </Form>
                  </div>

                  <div className="user-merchants__right-col_wrapper">
                    <TEXT.sectionDescription>% {t('admin.fee_client_replenishment')}</TEXT.sectionDescription>
                    <Form
                      name="user-merchant-form"
                      initialValues={{
                        systemFeePercentClient: merchant.systemFeeClient >= 0 ? merchant?.systemFeeClient : adminSettingsData.systemFeePercentClient,
                      }}
                      onFinish={({ systemFeePercentClient }) =>
                        updateMerchant(merchant._id, systemFeePercentClient, 'replenishClients')
                      }
                    >
                      <div className="user-merchants__input-wrap">
                        <PercentInput name="systemFeePercentClient" className="user-merchants__input" />
                        <button
                          type="submit"
                          className="user-merchants__save"
                          disabled={(systemFeePercentClientFetching && fetchingId[merchant._id]) || (permissions && permissions?.length > 0 && !permissions[1]?.edit) || (permissions && permissions?.length > 0 && !permissions[2]?.edit)}
                        >
                          {systemFeePercentClientFetching && fetchingId[merchant._id] ? spinIndicator : saveIcon[identity]}
                        </button>
                      </div>
                    </Form>
                  </div>

                  <div className="user-merchants__right-col_wrapper">
                    <TEXT.sectionDescription>% {t('admin.fee_checkout_replenishment')}</TEXT.sectionDescription>
                    <Form
                      name="user-merchant-form"
                      initialValues={{
                        systemFeeReplenish:
                          merchant.systemFeeReplenish >= 0
                            ? merchant.systemFeeReplenish
                            : adminSettingsData.systemFeePercentReplenish,
                      }}
                      onFinish={({ systemFeeReplenish }) =>
                        updateMerchant(merchant._id, systemFeeReplenish, 'replenish')
                      }
                    >
                      <div className="user-merchants__input-wrap">
                        <PercentInput name="systemFeeReplenish" className="user-merchants__input" />
                        <button
                          type="submit"
                          className="user-merchants__save"
                          disabled={(systemFeeFetching && fetchingId[merchant._id]) || (permissions && permissions?.length > 0 && !permissions[1]?.edit) || (permissions && permissions?.length > 0 && !permissions[2]?.edit)}
                        >
                          {systemFeeReplenishFetching && fetchingId[merchant._id] ? spinIndicator : saveIcon[identity]}
                        </button>
                      </div>
                    </Form>
                  </div>

                  <div className="user-merchants__right-col_wrapper">
                    <TEXT.sectionDescription>% {t('admin.fee_swap')}</TEXT.sectionDescription>
                    <Form
                      name="user-merchant-form"
                      initialValues={{
                        systemFeeSwap: merchant?.systemFeeSwap ?? adminSettingsData.systemFeePercentSwap,
                      }}
                      onFinish={({ systemFeeSwap }) => updateMerchant(merchant._id, systemFeeSwap, 'swap')}
                    >
                      <div className="user-merchants__input-wrap">
                        <PercentInput name="systemFeeSwap" className="user-merchants__input" />
                        <button
                          type="submit"
                          className="user-merchants__save"
                          disabled={(systemFeeSwapFetching && fetchingId[merchant._id]) || (permissions && permissions?.length > 0 && !permissions[1]?.edit) || (permissions && permissions?.length > 0 && !permissions[2]?.edit)}
                        >
                          {systemFeeSwapFetching && fetchingId[merchant._id] ? spinIndicator : saveIcon[identity]}
                        </button>
                      </div>
                    </Form>
                  </div>

                  <div className="user-merchants__right-col_wrapper">
                    <TEXT.sectionDescription>$ {t('admin.refund_limit')}</TEXT.sectionDescription>
                    <Form
                      name="user-merchant-form"
                      initialValues={{
                        refund: merchant?.refundLimitUsd ?? adminSettingsData.refundLimitUsd,
                      }}
                      onFinish={({ refund }) => updateMerchant(merchant._id, refund, 'refund')}
                    >
                      <div className="user-merchants__input-wrap">
                        <NumberInputSettings name="refund" className="user-merchants__input" />
                        <button
                          type="submit"
                          className="user-merchants__save"
                          disabled={(systemRefundFetching && fetchingId[merchant._id]) || (permissions && permissions?.length > 0 && !permissions[1]?.edit) || (permissions && permissions?.length > 0 && !permissions[2]?.edit)}
                        >
                          {systemRefundFetching && fetchingId[merchant._id] ? spinIndicator : saveIcon[identity]}
                        </button>
                      </div>
                    </Form>
                  </div>
                  <div className="user-merchants__right-col_wrapper">
                    <TEXT.sectionDescription>$ {t('admin.minimum_withdrawal')}</TEXT.sectionDescription>
                    <Form
                      name="user-merchant-form"
                      initialValues={{
                        minWithdraw: merchant?.minimumWithdrawalUsd ?? adminSettingsData.minimumWithdrawalUsd,
                      }}
                      onFinish={({ minWithdraw }) => updateMerchant(merchant._id, minWithdraw, 'minWithdraw')}
                    >
                      <div className="user-merchants__input-wrap">
                        <NumberInputSettings name="minWithdraw" className="user-merchants__input" />
                        <button
                          type="submit"
                          className="user-merchants__save"
                          disabled={(systemsMinimumWithdrawalFetching && fetchingId[merchant._id]) || (permissions && permissions?.length > 0 && !permissions[1]?.edit) || (permissions && permissions?.length > 0 && !permissions[2]?.edit)}
                        >
                          {systemsMinimumWithdrawalFetching && fetchingId[merchant._id] ? spinIndicator : saveIcon[identity]}
                        </button>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <Spin className="user-merchants__loader" indicator={<LoadingOutlined className={`spin-${identity}`} style={{ fontSize: 24 }} spin />} />
          )}
        </div>
      </Card>
      <div className="user-merchants-buttons">
        <Link to="/admin/users">
          <ButtonSecondary>{t('admin.back')}</ButtonSecondary>
        </Link>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  userMerchants: state.adminUsers.userMerchants.data,
  userMerchantsFetching: state.adminUsers.userMerchants.fetching,
  adminSettingsData: state.adminSettings.data,
  systemFeeFetching: state.adminUsers.userMerchants.systemFeeFetching,
  systemFeePercentClientFetching: state.adminUsers.userMerchants.systemFeePercentClientFetching,
  systemFeeReplenishFetching: state.adminUsers.userMerchants.systemFeeReplenishFetching,
  systemFeeSwapFetching: state.adminUsers.userMerchants.systemFeeSwapFetching,
  systemRefundFetching: state.adminUsers.userMerchants.systemRefundFetching,
  systemsMinimumWithdrawalFetching: state.adminUsers.userMerchants.systemsMinimumWithdrawalFetching,
  permissions: state.adminSettings.permissions,
});

const mapDispatchToProps = {
  getUserMerchants,
  updateMerchantsSystemFee,
  getAdminSettings,
  updateMerchantsSystemFeeReplenish,
  updateMerchantsSystemFeePercentClient,
  updateMerchantsSystemSwapReplenish,
  updateMerchantsRefundFee,
  updateMerchantsMinimumWithdrawal,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserMerchants);
